import { Component, OnInit } from '@angular/core';
import {MenubarModule} from 'primeng/menubar';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor() { }

  items: MenuItem[];

  ngOnInit() {
    this.items = [
      {label: 'Stolarstvo Krisanda', routerLink: ['onas']},
      {label: 'O nas', routerLink: ['onas']},
      {label: 'Galeria', routerLink: ['galeria']},
      {label: 'Kontakt', routerLink: ['kontakt']}
    ];

  }

}
